import KUSubmitOwner from './KUSubmitOwner'

export default KUSubmitOwner
